/* eslint-disable indent */
import clsx from 'clsx';
import { ITag } from '@/interfaces/articles';
import Link from 'next/link';

interface IProps {
  list: ITag[];
  listWrapperClassName?: string;
  itemClassName?: string;
  activeTags?: string[] | null;
}

export const Tags = ({ list, listWrapperClassName, itemClassName, activeTags }: IProps) => {
  return (
    <ul
      data-testid="tags"
      className={clsx(`flex flex-wrap`, { [`${listWrapperClassName}`]: listWrapperClassName })}
    >
      {list.map(({ title, href }, index) => (
        <li
          key={index}
          data-testid={`tag-${index}`}
          className={clsx(
            `
              flex items-center justify-center
              rounded-full border-[1px]
              text-xs leading-lg font-medium text-center
              ${
                activeTags && activeTags.includes(title)
                  ? 'border-purple-2 !bg-purple-2 text-purple-8'
                  : 'bg-white text-black-9 border-black-4'
              }
              ${href && 'transition-colors duration-300 ease-out hover:border-primary'}
            `,
            {
              [`${itemClassName}`]: itemClassName,
            },
          )}
        >
          {href ? (
            <Link
              className="py-[2px] px-[8px]"
              href={{
                pathname: href,
                query: { tags: title },
              }}
            >
              {title}
            </Link>
          ) : (
            <span className="py-[2px] px-[8px]">{title}</span>
          )}
        </li>
      ))}
    </ul>
  );
};
